var h = require('hyperscript')

module.exports = function () {
  return {
    template: render().outerHTML,
    controller: ['$scope', 'contentful', 'store', controller]
  }
}

function controller ($scope, contentful, store, $window) {

  $scope.allHexServicesProvided = []
  // $scope.allServices = [
  //   [],[],[],[],[],[],[],[],[]
  // ]
  $scope.setSelectedService = function (service) {
    store.set('selectedService', service)
  }
  contentful.entries('content_type=serviceTypes').then(function(res) {
    // console.log('services', res);
  $scope.allServices= res.data.items;
  $scope.serviceDetail= res.data.items[0];
  });
  // contentful.entries('content_type=home').then(function(res) {
  //   // console.log('services', res);
  // $scope.allServices= res.data.items[0].fields.homePageServices;
  //     console.log('home services', $scope.allServices);
  //
  // // $scope.serviceDetail= res.data.items[0];
  // });
  // contentful.entries('content_type=serviceTypes').then(function(res) {
  //   var allServiceTypes = res.data.items
  //
  // })
}

function render () {
  return h('#honeyHex', [
    h('.homeHoneyThree', [
      h("a.honeyCombHome", {
        'data-ng-click': 'setSelectedService(service)',
        'href': 'services/{{service.fields.slug}}',
       'data-ng-repeat': 'service in allServices',
       'data-ng-if': 'service.fields.slug === "architecture"',
      }, [
        h("img.overlayer", {
          "src":'img/ABS-HomeHex-architecture-green.png',
          'style': 'position:absolute;'
        }),
        h("img.honeyThumb", {
          "src":"img/ABS-HomeHex-architecture-hover.png"
        }),
        h("div.hexText", {
          "style":"height:284px;padding-top:53%;width:253px;position:absolute;z-index:2;text-align:center;top:-10px;padding-left:28px;padding-right:28px;",
        },[
          h("p", {
            "style":"font-weight:bold;color:white;text-transform: uppercase;top:58%;",
          }, "{{service.fields.pageTitle}}")
        ])
      ]),
      h("a.honeyCombHome", {
        'data-ng-click': 'setSelectedService(service)',
        'href': 'services/{{service.fields.slug}}',
        'data-ng-repeat': 'service in allServices',
        'data-ng-if': 'service.fields.slug === "building-enclosure"',
      }, [
        h("img.overlayer", {
          "src":'img/ABS-HomeHex-building-enclosure-green.png',
          'style': 'position:absolute;'
        }),
        h("img.honeyThumb", {
          "src":"img/ABS-HomeHex-building-enclosure-hover.png"
        }),
        h("div.hexText", {
          "style":"height:284px;padding-top:53%;width:253px;position:absolute;z-index:2;text-align:center;top:-10px;padding-left:28px;padding-right:28px;",
        },[
          h("p", {
            "style":"font-weight:bold;color:white;text-transform: uppercase; top:54%;",
          }, "{{service.fields.pageTitle}}")
        ])
      ]),
      h("a.honeyCombHome", {
        'data-ng-click': 'setSelectedService(service)',
        'href': 'services/{{service.fields.slug}}',
       'data-ng-repeat': 'service in allServices',
       'data-ng-if': 'service.fields.slug === "engineering"',
      }, [
        h("img.overlayer", {
          "src":'img/ABS-HomeHex-engineering-green.png',
          'style': 'position:absolute;'
        }),
        h("img.honeyThumb", {
          "src":"img/ABS-HomeHex-engineering-hover.png"
        }),
        h("div.hexText", {
          "style":"height:284px;padding-top:53%;width:253px;position:absolute;z-index:2;text-align:center;top:-10px;padding-left:28px;padding-right:28px;",
        }, [
          h("p", {
            "style":"font-weight:bold;color:white;text-transform: uppercase;top:58%;",
          }, "{{service.fields.pageTitle}}")
        ])
      ])
    ]),
    h('.homeHoneyTwo', [
      h("a.honeyCombHome", {
        'data-ng-click': 'setSelectedService(service)',
        'href': 'services/{{service.fields.slug}}',
       'data-ng-repeat': 'service in allServices',
       'data-ng-if': 'service.fields.slug === "forensic-consulting"',
      }, [
        h("img.overlayer", {
          "src":'img/ABS-HomeHex-forensic-consulting-green.png',
          'style': 'position:absolute;'
        }),
        h("img.honeyThumb", {
          "src":"img/ABS-HomeHex-forensic-consulting-hover.png"
        }),
        h("div.hexText", {
          "style":"height:284px;padding-top:53%;width:253px;position:absolute;z-index:2;text-align:center;top:-10px;padding-left:28px;padding-right:28px;",
        },[
          h("p", {
            "style":"font-weight:bold;color:white;text-transform: uppercase; top:52%;",
          }, "{{service.fields.pageTitle}}")
        ])
      ]),
      h("a.honeyCombHome", {
        'data-ng-click': 'setSelectedService(service)',
        'href': 'services/{{service.fields.slug}}',
       'data-ng-repeat': 'service in allServices',
       'data-ng-if': 'service.fields.slug === "life-safety-and-human-factors"',
      }, [
        h("img.overlayer", {
          "src":'img/ABS-HomeHex-life-safety-human-factors-green.png',
          'style': 'position:absolute;'
        }),
        h("img.honeyThumb", {
          "src":"img/ABS-HomeHex-life-safety-human-factors-hover.png"
        }),
        h("div.hexText", {
          "style":"height:284px;padding-top:53%;width:253px;position:absolute;z-index:2;text-align:center;top:-10px;padding-left:28px;padding-right:28px;",
        },[
          h("p", {
            "style":"font-weight:bold;color:white;text-transform: uppercase;top:49%;",
          }, "{{service.fields.pageTitle}}")
        ])
      ])
    ]),
  ])
}



/** WEBPACK FOOTER **
 ** ./components/homeHex.js
 **/